const ISO_DURATION_TRACK_LABELS: Record<string, string> = {
  P1D: '24 Hours',
  P1W: '7 Days',
  P1M: '1 Month',
  P6W: '6 Weeks',
  P6M: '6 Months',
  P9M: '9 Months',
  P1Y: '1 Year',
  P2Y: '2 Years',
  P5Y: '5 Years',
  P2147483647Y: 'Permanent',
};

type TimeOffSearchParams = {
  source?: string;
  type?: string;
  break?: string;
  period?: string;
};

type TimeOffTrackingAttributes = {
  feature: 'My Account' | 'Log In';
  container: 'Timeout Confirmed' | 'Self Exclusion Confirmed' | 'Timeout';
  period?: string;
};

function formatIsoDurationForTracking(isoPeriod: string): string {
  return ISO_DURATION_TRACK_LABELS[isoPeriod] ?? isoPeriod;
}

function isSelfExclusionConfirmed(params: TimeOffSearchParams): boolean {
  return params.break === 'self_exclusion' || (params.source === 'my-account' && params.type === 'self-exclusion');
}

function isTimeoutConfirmed(params: TimeOffSearchParams): boolean {
  if (params.break === 'timeout') {
    return Boolean(params.period);
  }

  return params.source === 'my-account' && params.type === 'timeout';
}

function getConfirmedTracking(container: TimeOffTrackingAttributes['container'], period?: string): TimeOffTrackingAttributes {
  return {
    feature: 'My Account',
    container,
    ...(period ? { period: formatIsoDurationForTracking(period) } : {}),
  };
}

function getTimeOffTracking(params: TimeOffSearchParams): TimeOffTrackingAttributes {
  if (isSelfExclusionConfirmed(params)) {
    return getConfirmedTracking('Self Exclusion Confirmed', params.period);
  }

  if (isTimeoutConfirmed(params)) {
    return getConfirmedTracking('Timeout Confirmed', params.period);
  }

  return {
    feature: 'Log In',
    container: 'Timeout',
  };
}

export { formatIsoDurationForTracking, getTimeOffTracking };
export type { TimeOffSearchParams, TimeOffTrackingAttributes };
